exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* UU5.Forms.BasicForm */\n.uu5-forms-basic-form > .uu5-bricks-header {\n  text-align: center;\n}\n.uu5-forms-basic-form-buttons {\n  margin-top: 2em;\n  text-align: center;\n}\n.uu5-forms-basic-form-buttons .uu5-bricks-button {\n  width: 100%;\n  margin-bottom: 10px;\n}\n@media (min-width: 768px) {\n  .uu5-forms-basic-form-buttons .uu5-bricks-button {\n    width: inherit;\n    min-width: 100px;\n  }\n  .uu5-forms-basic-form .uu5-bricks-button + .uu5-bricks-button {\n    margin-left: 1em;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./forms/basic-form.less
// module id = 313
// module chunks = 0